module.exports = __webpack_public_path__ + "static/media/cert_36.76fc38db.jpg";